import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/feature/PageMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { aboutData, testimonials } from '@/mocks/about';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 奶水乐园',
  description: '奶水乐园是国内领先的母乳喂养知识分享平台，致力于为每一位哺乳期妈妈提供专业、科学、温暖的母乳喂养知识。',
  url: 'https://naishuileyuan.com/about',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '奶水乐园',
  url: 'https://naishuileyuan.com',
  description: '国内领先的母乳喂养知识分享平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6688',
    contactType: 'customer service',
    email: 'hello@naishuileyuan.com',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '建国路88号SOHO现代城A座1208室',
    addressLocality: '北京市朝阳区',
    addressRegion: '北京',
    postalCode: '100022',
    addressCountry: 'CN',
  },
};

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    const formData = new FormData(form);

    try {
      const res = await fetch('https://readdy.ai/api/form/d9sn4bp4ne17ei0sdkbg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.toLowerCase().includes('spam')) {
          setFormStatus('success');
          form.reset();
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="关于我们 - 奶水乐园"
        description="奶水乐园是国内领先的母乳喂养知识分享平台，致力于为每一位哺乳期妈妈提供专业、科学、温暖的母乳喂养知识。了解我们的品牌故事、团队理念和联系方式。"
        keywords="奶水乐园,关于我们,母乳喂养平台,哺乳期知识,品牌介绍,联系方式"
        canonicalUrl="https://naishuileyuan.com/about"
      />
      <SchemaOrg data={aboutSchema} />
      <SchemaOrg data={orgSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          {/* Hero */}
          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                关于奶水乐园
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                {aboutData.slogan}
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed [&_p]:mb-4">
                {aboutData.intro.split('\n\n').map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {aboutData.stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Features */}
          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                为什么选择奶水乐园
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutData.features.map((feature, i) => (
                  <div key={i} className="bg-background-50 border border-background-200/60 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                      <i className={`${feature.icon} text-primary-600 text-xl`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-2">{feature.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                妈妈们的好评
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t, i) => (
                  <div key={i} className="bg-background-50 border border-background-200/60 rounded-xl p-5">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                        <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                        <div className="text-xs text-foreground-500">{t.role}</div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{t.content}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-4">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">地址</div>
                        <div className="text-sm text-foreground-600">{aboutData.contact.address}</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">电话</div>
                        <div className="text-sm text-foreground-600">{aboutData.contact.phone}</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">邮箱</div>
                        <div className="text-sm text-foreground-600">{aboutData.contact.email}</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-time-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">工作时间</div>
                        <div className="text-sm text-foreground-600">{aboutData.contact.workHours}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-4">发送消息</h3>
                  <form onSubmit={handleSubmit} data-readdy-form className="space-y-4" noValidate>
                    <div>
                      <label htmlFor="about-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                      <input
                        type="text"
                        id="about-name"
                        name="name"
                        required
                        className="w-full px-3 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        type="email"
                        id="about-email"
                        name="email"
                        required
                        className="w-full px-3 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-message" className="block text-sm text-foreground-700 mb-1.5">留言</label>
                      <textarea
                        id="about-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-3 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                        placeholder="请输入您的留言（最多500字）"
                      ></textarea>
                      <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
                    </div>
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="absolute opacity-0 pointer-events-none" style={{ position: 'absolute', left: '-9999px' }} />
                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    >
                      {formStatus === 'submitting' ? '发送中...' : '发送消息'}
                    </button>

                    {formStatus === 'success' && (
                      <div className="text-sm text-green-600 text-center py-2">
                        消息已成功发送，我们会尽快回复您！
                      </div>
                    )}
                    {formStatus === 'error' && formError && (
                      <div className="text-sm text-red-500 text-center py-2">
                        {formError}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}